import { createSelector } from '@reduxjs/toolkit'

import { getGeoBlockedGameCodes } from 'config/geoBlockedContent'
import { getLocationDataSelector } from 'store/modules/appConfig/selectors'

/**
 * PLDV-8952 — geo-blocked content, kept in its own module (like
 * `disabledContentSelectors`) so `games/selectors` stays free of a dependency on
 * the appConfig slice.
 */

/**
 * Blocked game codes for the customer's current state, `null` when nothing is
 * blocked. The state reflects the last GetAccountInfoResponse; until it arrives
 * `appConfig.location` is null and nothing is blocked, which matches the play-page
 * flow where `GameRedirectWrapper` holds rendering until the app is initialised.
 */
export const geoBlockedGameCodesSelector = createSelector(getLocationDataSelector, (location) =>
  getGeoBlockedGameCodes(location?.state),
)
